import { useEffect, useState } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { Close, SupportAgent } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { SUPPORT_NOTIFICATION_EVENT, clearSupportUnreadCount } from "utils/supportNotifications";

const SupportNotificationToast = () => {
  const navigate = useNavigate();
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const handleEvent = (event) => {
      const notification = event?.detail?.notification;
      if (!notification) return;
      setToasts((prev) => [notification, ...prev].slice(0, 3));
      window.setTimeout(() => {
        setToasts((prev) => prev.filter((item) => item.id !== notification.id));
      }, 5000);
    };
    window.addEventListener(SUPPORT_NOTIFICATION_EVENT, handleEvent);
    return () => window.removeEventListener(SUPPORT_NOTIFICATION_EVENT, handleEvent);
  }, []);

  if (!toasts.length) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 24,
        right: 24,
        zIndex: 2000,
        display: "flex",
        flexDirection: "column",
        gap: 1.25,
        width: 340,
        maxWidth: "calc(100vw - 32px)",
      }}
    >
      {toasts.map((item) => (
        <Box
          key={item.id}
          onClick={() => {
            clearSupportUnreadCount();
            navigate("/dashboard/support");
            setToasts((prev) => prev.filter((toast) => toast.id !== item.id));
          }}
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 1.25,
            p: 1.5,
            borderRadius: 3,
            bgcolor: "background.paper",
            boxShadow: "0 12px 32px rgba(0,0,0,0.18)",
            border: "1px solid",
            borderColor: "divider",
            cursor: "pointer",
          }}
        >
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              bgcolor: "error.main",
              color: "error.contrastText",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <SupportAgent fontSize="small" />
          </Box>
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Typography variant="subtitle2" fontWeight={700} noWrap>
              New support request
            </Typography>
            <Typography variant="body2" color="text.secondary" noWrap>
              {item.title}
            </Typography>
            <Typography variant="caption" color="text.disabled">
              Just now
            </Typography>
          </Box>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              setToasts((prev) => prev.filter((toast) => toast.id !== item.id));
            }}
          >
            <Close fontSize="small" />
          </IconButton>
        </Box>
      ))}
    </Box>
  );
};

export default SupportNotificationToast;
